import React from "react"
import PropTypes from "prop-types"
import * as css from "./KeyValue.module.css"

const KeyValue = ({ label, value }) => {
  if (label === undefined || value === undefined) {
    return null
  }

  return (
    <div className={`keyvalue ${css.wrapper}`}>
      <div className={css.key}>{label}</div>
      <div className={css.value}>
        {value instanceof Function ? value() : value}
      </div>
    </div>
  )
}

KeyValue.propTypes = {
  label: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

export { KeyValue }
